/** Imágenes en src/assets/images/proyectos/ (origen: frontend/assets/images/) */
import kipoImg from "../assets/images/proyectos/kipo.png";
import fotografiaiaImg from "../assets/images/proyectos/fotografiaia.png";
import djangoScannerImg from "../assets/images/proyectos/djangosecurityscanner.png";
import campoconectaImg from "../assets/images/proyectos/campoconecta.png";
import almaImg from "../assets/images/proyectos/almaconexionplata2.png";
import webpagesImg from "../assets/images/proyectos/webpages.png";
import cvagenticImg from "../assets/images/proyectos/cvagentic.png";

/** Apps publicadas en tiendas */
export const PROYECTOS = [
    {
        nombre: "Nuestras páginas web",
        descripcion:
            "Todas las páginas web que construimos para negocios, disponibles en el navegador y desde nuestra app móvil.",
        url: "https://play.google.com/store/apps/details?id=com.emmpieza.tunegocioonline",
        urlWeb: "https://webpages.emmpieza.com/",
        tipo: "Web y aplicación móvil",
        imagen: webpagesImg,
    },
    {
        nombre: "Emmpieza a Analizar tu CV",
        descripcion:
            "Analizador de hojas de vida con IA: evalúa y da retroalimentación automática sobre el CV subido.",
        urlWeb: "https://cvanalyzer.emmpieza.com/",
        tipo: "Aplicación web con IA",
        imagen: cvagenticImg,
    },
    {
        nombre: "Alma Conexión Plata",
        descripcion:
            "Plataforma para poder realizar videollamadas, subir cursos de meditación y videos de bienestar",
        url: "https://play.google.com/store/apps/details?id=com.emmpieza.almaconexionplata&hl=es_CO",
        tipo: "Aplicación móvil",
        imagen: almaImg,
    },
    {
        nombre: "CampoConecta",
        descripcion:
            "Marketplace agrícola que conecta campesinos con compradores usando Android y nube.",
        url: "https://play.google.com/store/apps/details?id=com.emmpieza.tuappagricolamarket&hl=es_CO",
        tipo: "Aplicación móvil",
        imagen: campoconectaImg,
        casePath: "/casos/campoconecta",
    },
];

/** Casos de éxito — filtros: All, AI, Web, Mobile, Cybersecurity */
export const CASOS_EXITO = [
    {
        categoria: "Web",
        categoria_tag: "WEBSITE",
        titulo: "Kipo",
        reto: "Es una plataforma para solicitar préstamos empresariales.",
        solucion:
            "Desarrollamos la aplicación web responsive, con autenticación y el sistema de préstamos completo.",
        metrica: "Website",
        metrica_etiqueta: "Rendimiento",
        url: "https://kipo.com.co/",
        imagen: kipoImg,
    },
    {
        categoria: "AI",
        categoria_tag: "AI",
        titulo: "Convertir Fotografía con IA",
        reto: "Crear un formulario para obtener los datos de la persona y permitirle subir una foto y convertirla al tipo deseado del usuario.",
        solucion:
            "Se creó un formulario para la autenticación y luego permitiendo subir una imagen desde el celular de galería o foto y convirtiéndola a animada.",
        metrica: "IA Website",
        metrica_etiqueta: "Website",
        url: "https://inteligenciaartificial.emmpieza.com/",
        imagen: fotografiaiaImg,
    },
    {
        categoria: "Cybersecurity",
        categoria_tag: "CYBERSECURITY",
        titulo: "Scanner Django VSecurityCode",
        reto: "Extensión para escanear vulnerabilidades en aplicaciones Django.",
        solucion:
            "Extensión para escanear vulnerabilidades en aplicaciones Django; te entrega un reporte con las vulnerabilidades encontradas.",
        metrica: "Pentesting",
        metrica_etiqueta: "Cybersecurity",
        url: "https://github.com/3p1c0w3nd/extension-vs-scan-vuln-django",
        imagen: djangoScannerImg,
        casePath: "/casos/scanner-django-vsecuritycode",
    },
    {
        categoria: "Mobile",
        categoria_tag: "MOBILE",
        titulo: "CampoConecta",
        reto: "Conectar a campesinos con compradores y dar visibilidad a precios y cosechas en tiempo real.",
        solucion:
            "App Android con marketplace, geolocalización, notificaciones y panel web para administradores.",
        metrica: "Mobile App",
        metrica_etiqueta: "Mobile",
        url: "https://play.google.com/store/apps/details?id=com.emmpieza.tuappagricolamarket&hl=es_CO",
        imagen: campoconectaImg,
        casePath: "/casos/campoconecta",
    },
    {
        categoria: "Mobile",
        categoria_tag: "MOBILE",
        titulo: "Alma Conexión Plata",
        reto: "Plataforma para poder realizar videollamadas, subir cursos de meditación y videos de bienestar.",
        solucion:
            "La app permite la integración de videollamadas, creación de podcast, subir PDF, audios y notificaciones push a los usuarios; se encuentra en Play Store y App Store.",
        metrica: "Mobile App",
        metrica_etiqueta: "Mobile",
        urlandroid:
            "https://play.google.com/store/apps/details?id=com.emmpieza.almaconexionplata&hl=es_CO",
        urlios: "https://apps.apple.com/co/app/alma-conexion-plata/id6756738715",
        imagen: almaImg,
    },
];

export const FILTROS_CASOS = ["All", "AI", "Web", "Mobile", "Cybersecurity"];
